
import { supabase } from "@/integrations/supabase/client";

/**
 * Execute a BigQuery SQL query through the Supabase Edge Function
 * @param query The SQL query to execute
 * @param params Optional array of parameter values
 * @returns A Promise resolving to the query results
 */
export async function executeBigQuery(query: string, params: any[] = []) {
  try {
    console.log("Executing BigQuery with params:", params);
    
    const { data, error } = await supabase.functions.invoke('bigquery-access', {
      body: { query, params },
    });
    
    if (error) {
      console.error('Error calling BigQuery function:', error);
      throw new Error(error.message || 'Failed to execute BigQuery');
    }
    
    return data.data;
  } catch (error) {
    console.error('Error in executeBigQuery:', error);
    throw error;
  }
}

/**
 * Example function to fetch data from a specific BigQuery table
 * @param tableName The BigQuery table name including dataset (e.g., 'dataset.table')
 * @param limit Maximum number of rows to return
 * @returns Promise resolving to table data
 */
export async function fetchTableData(tableName: string, limit = 100) {
  const query = `SELECT * FROM \`${tableName}\` LIMIT @limit`;
  return executeBigQuery(query, [limit]);
}

/**
 * Update MSN field in the BigQuery table for a specific nanoid
 * @param nanoid The nanoid to identify the record
 * @param phoneNumber The phone number to update
 * @returns Promise resolving to the query results
 */
export async function updateMSN(nanoid: string, phoneNumber: string) {
  // Clean the phone number (remove non-digits)
  const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
  
  const query = `
    UPDATE \`lottosocial-9f7a2.customerSync.syncBulkSMSfromIntegrate\`
    SET MSN = @phoneNumber
    WHERE nanoid = @nanoid
  `;
  
  return executeBigQuery(query, [cleanedPhoneNumber, nanoid]);
}
